import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import type { ExtractGetRoutes, RouteSegment } from '@openclassrooms/sdk';
import get from '../services/get';
import checkGetRetry from '../services/checkGetRetry';
import type { ApiRoutes, GetRequestBuilder, RequestOption } from '../types';
import useQueryKeys from './useQueryKeys';
export default function useInfiniteGet(path, options) {
  const $ = _c(29);
  let t0;
  if ($[0] !== options) {
    t0 = options || {};
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let customQueryKey;
  let enabled;
  let initialPagination;
  let otherOptions;
  let t1;
  if ($[2] !== t0) {
    ({
      watchedQueryKeys: t1,
      queryKey: customQueryKey,
      enabled,
      initialPagination,
      ...otherOptions
    } = t0);
    $[2] = t0;
    $[3] = customQueryKey;
    $[4] = enabled;
    $[5] = initialPagination;
    $[6] = otherOptions;
    $[7] = t1;
  } else {
    customQueryKey = $[3];
    enabled = $[4];
    initialPagination = $[5];
    otherOptions = $[6];
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const watchedQueryKeys = t2;
  let t3;
  if ($[10] !== initialPagination) {
    t3 = initialPagination || {};
    $[10] = initialPagination;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const {
    rangeStart: t4,
    rangeEnd: t5
  } = t3;
  const initalRangeStart = t4 === undefined ? 0 : t4;
  const initalRangeEnd = t5 === undefined ? 19 : t5;
  const perPage = initalRangeEnd - initalRangeStart + 1;
  const t6 = Math.floor(initalRangeStart / perPage) + 1;
  let t7;
  if ($[12] !== perPage || $[13] !== t6) {
    t7 = {
      itemsPerPage: perPage,
      initialPageParam: t6
    };
    $[12] = perPage;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const {
    itemsPerPage,
    initialPageParam
  } = t7;
  let t8;
  if ($[15] !== customQueryKey || $[16] !== otherOptions || $[17] !== path || $[18] !== watchedQueryKeys) {
    t8 = {
      path,
      customQueryKey,
      options: otherOptions,
      watchedQueryKeys
    };
    $[15] = customQueryKey;
    $[16] = otherOptions;
    $[17] = path;
    $[18] = watchedQueryKeys;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const queryKey = useQueryKeys(t8);
  let t9;
  if ($[20] !== itemsPerPage || $[21] !== otherOptions || $[22] !== path) {
    t9 = t10 => {
      const {
        pageParam
      } = t10;
      const rangeStart = (pageParam - 1) * itemsPerPage;
      const rangeEnd = pageParam * itemsPerPage - 1;
      return get(path, {
        ...(otherOptions as any),
        pagination: {
          rangeStart,
          rangeEnd
        }
      });
    };
    $[20] = itemsPerPage;
    $[21] = otherOptions;
    $[22] = path;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== enabled || $[25] !== initialPageParam || $[26] !== queryKey || $[27] !== t9) {
    t10 = {
      queryKey,
      queryFn: t9,
      initialPageParam,
      getNextPageParam: _temp,
      staleTime: 5000,
      enabled,
      retry: checkGetRetry
    };
    $[24] = enabled;
    $[25] = initialPageParam;
    $[26] = queryKey;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return useInfiniteQuery(t10);
}
function _temp(lastPage) {
  if (lastPage.paginationData.hasNextPage) {
    return lastPage.paginationData.currentPage + 1;
  }
}